import React from 'react';

const AgendaEmptyState = ({ message }) => {
    return (
        <div className="ventas-empty-state" role="status">
            <i className="pi pi-calendar-times" aria-hidden="true" />
            <span>{message}</span>
        </div>
    );
};

export default AgendaEmptyState;
